import React, { useEffect } from 'react'
import { Grid, Stack } from '@mui/material'
import i18n from 'simple-react-i18n'
import PGSSEFilters from '../common/PGSSEFilters'
import useTitle from 'utils/customHook/useTitle'
import { PATH_PGSSE } from 'home/constants/RouteConstants'
import { CardTable } from 'components/datatable/NewTable'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { push } from '@lagunovsky/redux-react-router'
import PgsseAction from 'pgsse/action/PgsseAction'
import { getLabel } from 'utils/StoreUtils'
import { nbPerPageLabelHuge } from 'referencial/constants/ReferencialConstants'

const StatList = ({ }) => {
    const {
        contributors,
        distributionUnits,
        sectors,
        diagnosticIndicators,
    } = useSelector(store => ({
        contributors: store.ContributorReducer.contributors,
        distributionUnits: store.DistributionUnitReducer.distributionUnits,
        sectors: store.SectorReducer.sectors,
        diagnosticIndicators: store.PgsseReducer.diagnosticIndicators,
    }), shallowEqual)

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(PgsseAction.fetchDashboardPhase4List({}))
    }, [])

    useTitle(() => [{
        title: i18n.pgsse,
        href: PATH_PGSSE,
    }, {
        title: i18n.phase4,
        href: `${PATH_PGSSE}/phase4`,
    }], [])

    const diagnosticStatsFormatted = diagnosticIndicators
        .map(d => {
            return {
                ...d,
                collectivity: getLabel(contributors, d.idContributor),
                sector: getLabel(sectors, d.idSector),
                udiCode: getLabel(distributionUnits, d.idUdi, 'code'),
                udi: getLabel(distributionUnits, d.idUdi),
            }
        })

    return (
        <Stack spacing={1} sx={{ padding: '10 10 10 20' }}>
            <Grid size={12}>
                <PGSSEFilters onValidate={filters => dispatch(PgsseAction.fetchDashboardPhase4List(filters))} />
            </Grid>
            <CardTable
                title={i18n.indicators}
                rows={diagnosticStatsFormatted}
                headers={['collectivity', 'sector', 'udiCode', 'udi', 'nbIndicators', 'nbFilledThisMonth', 'nbNotFilledThisMonth']}
                onClickRow={d => dispatch(push(`${PATH_PGSSE}/phase4/${d.idDiag}`))}
                rowsPerPageOptions={nbPerPageLabelHuge}
            />
        </Stack>
    )
}

StatList.PropTypes = {
}

export default StatList